import React from 'react';
import './BackGroundImg.css'

const BackGroundImg = () => {
    return (
        <div>
            <div>
                <div class="hero-image">
                    <div class="hero-text">

                        <p>Excellengt Service</p>
                        <p>Quick visa process</p>
                        <p>Cheap cost better Service</p>

                    </div>
                </div>
            </div>

        </div>
    );
};

export default BackGroundImg;